import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiRequestTicketsRequest extends ApiRequestor {
  async $post(payload) {
    return this.$http('POST', `ticketRequests`, {payload})
  }
}
